define(function (require) {

    window.lpTag = window.lpTag || {};
    window.lpTag.uiframework = window.lpTag.uiframework || {};

    var LPModel = require('web-agent-framework/LPModel');

    var configuration = window.LP_UIFRAMEWORK_NAMESPACE || "lpTag";
    var vehConfig = createConfigurationObject(configuration);

    function createConfigurationObject(configuration) {
        var returnConfig = {namespace: (configuration ? (configuration.namespace || configuration) : window)};

        if (typeof returnConfig.namespace === 'string') {
            var split = returnConfig.namespace.split('.');
            returnConfig.namespace = window;
            for (var i = 0 ; i < split.length ; i++) {
                returnConfig.namespace = returnConfig.namespace[split[i]] = (returnConfig.namespace[split[i]] || {});
            }
        }
        return returnConfig;
    }
    vehConfig.namespace.ViewEventsHandler = function (externalLogger) {
        var focusEvents = {focus: this.eventType.VISITOR_FOCUSED, blur: this.eventType.VISITOR_BLURRED};

        var appNameEventsMap = {};
        // In case we need to return the old LPModel
        //var viewModel = new vehConfig.namespace.LPModel(null, externalLogger);
        var viewModel = new LPModel(null, externalLogger);

        this.bindEvent = function (event) {
            if (!appNameEventsMap[event.appName]) {
                appNameEventsMap[event.appName] = {};
            }

            appNameEventsMap[event.appName][event.UIEvent] = true;
            viewModel.bind(event.appName + "_" + event.UIEvent, event.callback, event.context, event.trigger);
        };

        this.unbindEvent = function (event) {
            var callback = event.callback || null;
            var context = event.context || null;
            var eventName = null;

            if (event.appName) {
                eventName = event.appName;
                if (event.UIEvent) {
                    eventName = event.appName + "_" + event.UIEvent;
                } else {
                    for (var prop in appNameEventsMap[event.appName]) {
                        if (appNameEventsMap[event.appName].hasOwnProperty(prop)) {
                            var newEvent = {appName : event.appName, UIEvent : prop, context : context, callback : callback};
                            this.unbindEvent(newEvent);
                        }
                    }
                }
            }
            viewModel.unbind(eventName, callback, context);
        };

        this.fireEvent = function (event) {
            var eventData = {
                timeStamp : new Date().getTime(),
                appName : event.appName,
                UIEvent : event.UIEvent
            };
            if (event.eventData) {
                eventData.eventData = event.eventData;
            }


            if (event.UIEvent === focusEvents.focus || event.UIEvent === focusEvents.blur) {
                var key = event.appName + "_" + ((event.UIEvent === focusEvents.focus) ? focusEvents.blur : focusEvents.focus);

                if (viewModel.get(key)) {
                    viewModel.removeKey(key, false);
                }
            }

            viewModel.modify(event.appName + "_" + event.UIEvent, eventData);

            if (event.deleteOnFire) {
                viewModel.removeKey(event.appName + "_" + event.UIEvent, false);
            }
        };

        /**
         * This will remove any "Stale" data that has been stored in the model for event sourcing.
         * in case any "bindEventHandler" fire old stale data that is not relevant anymore.
         * see - LE-77329 - for more details.
         * @param appName
         */
        this.disposeEventData = function( appName ){
             // Iterating over all the EventTypes and remove the data from the key..
            for(var item in vehConfig.namespace.ViewEventsHandler.prototype.eventType){
                viewModel.removeKey(appName + '_'+ vehConfig.namespace.ViewEventsHandler.prototype.eventType[item]);
            }
        };

    };

    vehConfig.namespace.ViewEventsHandler.prototype.eventType = {
        PAGE_ROUTE: "pageRoute",
        VISITOR_FOCUSED : "visitorFocused",
        VISITOR_BLURRED : "visitorBlurred",
        VISITOR_DISPOSED : "visitorDisposed",
        VISITOR_SELECTED : "visitorSelected",
        VISITOR_VISIBILITY_CHANGED: "visitorVisibilityChanged",
        PRE_DEFINED_CONTENT_SELECTED : "preDefinedContentSelected",
        PRE_DEFINED_CONTENT_SHORTCUT : "preDefinedContentShortcut",
        CONTENT_SANITIZED : "contentSanitized",
        EXPAND : "expand",
        COLLAPSE : "collapse",
        TOUCH_SESSION : "touchSession",
        TABLE_CONTENT_CHANGED : "tableContentChanged",
        TABLE_FILTERING_CHANGED : "tableFilteringChanged",
        TABLE_SEARCH_FILTER_CHANGED: "tableSearchFilterChanged",
        TABLE_FILTER_OPENED : "tableFilterOpened",
        TABLE_FILTER_CLOSED : "tableFilterClosed",
        TABLE_WIDGETS_OPENED : "tableWidgetsOpened",
        TABLE_WIDGETS_CLOSED : "TableWidgetsClosed",
        TABLE_OFFLINE_ORB_OPENED : "tableOfflineOrbOpened",
        TABLE_OFFLINE_ORB_CLOSED : "TableOfflineOrbClosed",
        SHOW_FIRST_IN_QUEUE : "showFirstInQueue",
        NEXT_TO_TAKE_ACTION_REGISTER : "NTA_register",
        NEXT_TO_TAKE_ACTION_UNREGISTER : "NTA_unregister",
        SHOW_FILE_UPLOAD_PREVIEW: "showFileUploadPreview",
        SHOW_FILE_UPLOAD_ERROR: "showFileUploadError",
        WIDGET_CONTENT_SEND : "contentSend",
        CONTENT_ADDED_TO_CONVERSATION: "contentAdded"
    };

    return vehConfig.namespace.ViewEventsHandler;

});
